import React from 'react';
import './AdminPanelContainer.scss';
import SideNavBarComponent from '../../Components/AdminPanelComponent/SideNavBarComponent/SideNavBarComponent';
import { Route } from 'react-router-dom';
import ContactUsResponses from '../../Components/AdminPanelComponent/ContactUsResponses/ContactUsResponses';
import AddProject from '../../Components/AdminPanelComponent/AddProjectComponent/AddProject';
import AddImages from '../../Components/AdminPanelComponent/AddCarouselImagesComponent/AddImages';
import Subscribers from '../../Components/AdminPanelComponent/SubscribersComponent/Subscribers';
import ManageUsersComponent from '../../Components/AdminPanelComponent/ManageUsersComponent/ManageUsersComponent';

const AdminPanelContainer = () => {
	return (
		<>
			<div className="admin-dashboard">
				<div>
					<SideNavBarComponent />
				</div>
				<div className='right-side-content'>
					<Route path='/admin-panel/' exact component={AddProject} />
					<Route path='/admin-panel/user-accounts' component={ManageUsersComponent} />
					<Route path='/admin-panel/manage-carousel' exact component={AddImages} />
					<Route path='/admin-panel/contactusresponses' exact component={ContactUsResponses} />
					<Route path='/admin-panel/subscribers' exact component={Subscribers} />
				</div>

			</div>
		</>
	);
};

export default AdminPanelContainer;
